import React from 'react';
import AssetTeamNavBar from '../../../../../layouts/asset-team/AssetTeamNavBar';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import ActiveCustomersPerZoneBody from './ActiveCustomersPerZoneBody';
import CustomerSupportNavBar from '../../../../../layouts/customer-support/CustomerSupportNavBar';

const CustomerSupportActiveCustomersPerZone = () => {
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <CustomerSupportNavBar currentPage="Active Customers Per Zone" position={firstName} />
        <ActiveCustomersPerZoneBody />
      </main>
    </div>
  );
};

export default CustomerSupportActiveCustomersPerZone;
